<template>
  <BaseLayout>
    <template v-slot:top_buttons>
    <div class="d-flex justify-content-end mb-2">
            <DocLink docKey="pricing" text="Помощь по разделу" />
          </div>
        </template>
    <div class="card">
      <div class="card-body">
        <LoadingBlock :loading="loadingSettings">
          <div class="row gy-sm-1 price-top-row">
            <div class="col-md-5 mt-2">
              <label class="form-label">Поиск по товарам</label>
              <div class="d-flex">
                <input type="text" class="form-control border-1 py-2 me-2" placeholder="Название, код товара, бренд"
                  v-model="searchData.name" @change="search">
                <ProductFilters 
                  :store_id="activeStores.length > 0 ? activeStores[0] : null" 
                  :store_name="firstActiveStoreName"
                  :order_type="OrderType"
                  @filtersChanged="handleProductFiltersChanged" 
                />
              </div>
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Магазины</label>
              <MultiSelect v-model="activeStores" :options="stores" optionLabel="name" optionValue="id"
                :showToggleAll="false" @change="setActiveStores" placeholder="Магазин не выбран" :maxSelectedLabels="3"
                style="width: 100%">
                <template #option="slotProps">
                  <div class="d-flex align-content-center">
                    <img :src="slotProps.option.icon" alt="Маркетплейс" width="20px" style="margin-right: 3px">
                    <span>{{ slotProps.option.name }}</span>
                  </div>
                </template>
              </MultiSelect>

            </div>

            <div class="col-md-2 mt-2">
              <label class="form-label">Модель работы</label>
              <Select v-model="OrderType" :options="OrderTypes" optionLabel="name" optionValue="value"
                placeholder="Модель работы" style="width: 100%" @change="updateSettings" />

            </div>

            <div class="col-md-2 mt-2">
              <label class="form-label">Столбцы</label>
              <MultiSelect v-model="SelectedColumns" :options="columns" optionLabel="name" optionValue="code"
                placeholder="Столбцы" style="width: 100%" :showToggleAll="false" @change="updateSettings" />

            </div>
            <div class="col-md-1 mt-2 align-content-end" style="text-align: right">
              <button class="btn w-100 btn-outline-secondary waves-effect mb-1" @click="openSettings">
                <i class="ti ti-settings"></i>
              </button>
            </div>
          </div>
          <div v-if="!products.length && !loadingProducts" class="mt-7">
            Товары не найдены
          </div>
        </LoadingBlock>
      </div>
      <div>
        <LoadingBlock :loading="loadingOffers || loadingProducts">
          <ag-grid-vue ref="pricesGrid" v-if="products.length" :rowData="rowData" :columnDefs="colDefs"
            :onCellValueChanged="onCellValueChanged" :copySelectedRows="true" :tooltipInteraction="true"
            :tooltipShowDelay="0" :getRowId="getRowId" :gridOptions="gridOptions" suppressNoRowsOverlay="true"
            @grid-ready="onGridReady" domLayout="autoHeight" style="width: 100%;" class="ag-theme-quartz prices-grid">
          </ag-grid-vue>

          <BasePagination :info="paginationInfo" ref="productsPagination" @changePage="changePage">
          </BasePagination>
        </LoadingBlock>
      </div>
    </div>
    <OffCanvas ref="priceCanvas" :title="'Настройки'">
      <h6 class="mb-1">Загрузить цены из маркетплейса</h6>
      <div class="row">
        <div class="col-md-6 mt-2">
          <label class="form-label">Магазин</label>
          <Select v-model="storeToUpdate" :options="stores" optionLabel="name" optionValue="id"
            placeholder="Магазин не выбран" style="width: 100%" />
        </div>
        <div class="col-md-6 align-content-end mt-2">
          <ButtonComponent ref="getOffersButton" :class="'btn w-100 btn-outline-secondary waves-effect'"
            @click="storeGetOffers()">Загрузить
          </ButtonComponent>
        </div>
        <h6 class="mb-1 mt-4">Параметры ценообразования</h6>
        <div class="col-md-12 mt-3">
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" v-model="controlMinPrice" id="controlMinPrice"
              @change="updateSettings(false)">
            <label class="form-check-label" for="controlMinPrice">Контролировать РРЦ с учетом скидок
              маркетплейса</label>
          </div>
          <div v-if="controlMinPrice && !selectedStoresAreOnlyYandex" class="mt-3">
            <label class="form-label" for="rrpPriceType">
              На какую цену ориентировать РРЦ
              <i
                class="ti ti-info-circle ti-sm ms-1"
                v-tooltip.bottom="RrpPriceTypeHint"
              ></i>
            </label>
            <Select
              v-model="rrpPriceType"
              :options="RrpPriceTypes"
              optionLabel="label"
              optionValue="value"
              inputId="rrpPriceType"
              placeholder="Тип цены РРЦ"
              style="width: 100%"
              @change="updateSettings(false)"
            >
              <template #value="slotProps">
                <div class="d-flex align-items-center" v-if="slotProps.value != null && slotProps.value !== ''">
                  <span>{{ rrpPriceTypeLabel(slotProps.value) }}</span>
                  <span v-if="isRrpPriceTypeBeta(slotProps.value)" class="rrp-beta ms-2">Beta</span>
                </div>
                <span v-else>{{ slotProps.placeholder }}</span>
              </template>
              <template #option="slotProps">
                <div class="d-flex align-items-center">
                  <span>{{ slotProps.option.label }}</span>
                  <span v-if="slotProps.option.beta" class="rrp-beta ms-2">Beta</span>
                </div>
              </template>
            </Select>
            <div v-if="needsShowcaseTracking" class="alert alert-secondary py-2 mb-0 mt-2" role="alert">
              {{ RrpPriceTypeTrackingHint }}
              <router-link :to="SHOWCASE_PRICES_PATH" target="_blank" rel="noopener noreferrer">Цены на витрине</router-link>
            </div>
          </div>
          <div class="form-check form-switch mt-3">
            <input class="form-check-input" type="checkbox" v-model="askIfDifference" id="askIfDifference"
              @change="updateSettings(false)">
            <label class="form-check-label" for="askIfDifference">Спрашивать при резком изменении цены</label>
          </div>
          
        <template v-if="selectedStoreIsWb">
          <template v-if="OrderType === 'fbs'">
            <div class="col-md-12 mt-3">
              <label class="form-label">WB: cклад отгрузки обычных товаров</label>
              <Select v-model="wbWarehouseCode" :options="wbWarehousesForFbs" optionLabel="_label" optionValue="code"
                      placeholder="По умолчанию" style="width: 100%" :loading="loadingWbWarehouses" :filter="true" @change="updateSettings()" />
            </div>
            <div class="col-md-12 mt-3">
              <label class="form-label">WB: cклад отгрузки СГТ товаров</label>
              <Select v-model="wbWarehouseSgtCode" :options="wbWarehousesForFbs" optionLabel="_label" optionValue="code"
                      placeholder="По умолчанию" style="width: 100%" :loading="loadingWbWarehouses" :filter="true" @change="updateSettings()" />
            </div>
          </template>
          <template v-if="OrderType === 'fbo'">
            <div class="col-md-12 mt-3">
              <label class="form-label">WB: тип поставки</label>
              <Select v-model="wbSupplyType" :options="wbSupplyTypes" optionLabel="label" optionValue="value"
                      placeholder="По умолчанию" style="width: 100%" @change="updateSettings()" />
            </div>
            <div class="col-md-12 mt-3">
              <label class="form-label">WB: склад отгрузки FBO товаров</label>
              <Select v-model="wbFboWarehouseCode" :options="wbWarehousesForFbo" optionLabel="_label" optionValue="code"
                      placeholder="По умолчанию" style="width: 100%" :loading="loadingWbWarehouses" :filter="true" @change="updateSettings()" />
            </div>
          </template>
        </template>
        <template v-if="selectedStoreIsOzon">
          <div class="col-md-12 mt-3">
            <label class="form-label">Ozon: действие при наличии минимальной цены</label>
            <Select v-model="additional_params.ozon_min_price_action" :options="ozon_min_price_actions" optionLabel="label" optionValue="value"
                    placeholder="По умолчанию" style="width: 100%" @change="updateSettings()" />
          </div>
        </template>
        </div>
      </div>
    </OffCanvas>
  </BaseLayout>
  <ConfirmModal ref="confirmModal" :title="confirmModalData.title" :message="confirmModalData.message"
    :buttons="confirmModalData.buttons" />
</template>

<script>
import BaseLayout from '@/layouts/Base.vue'
import { PageInfo } from "@/data/page";
import { user } from "@/data/user";
import { getMarketplaceIcon, stores } from "@/data/store";
import { price } from "@/data/price";
import { subscription } from "@/data/subscription";
import router from "@/router";
import { getProductsPost, updateCosts, updateMinPrices } from "@/api/product";
import BasePagination from "@/components/list/Pagination.vue"
import MarketplaceTooltip from "@/components/price/Marketplace.vue"
import CommissionTooltip from "@/components/price/Commission.vue"
import { getOffers as StoreGetOffers, getWbWarehouses } from "@/api/store"
import { OrderTypes } from "@/data/orders";
import { RrpPriceTypes, RrpPriceTypeHint, RrpPriceTypeTrackingHint, SHOWCASE_PRICES_PATH, formatRrpPriceType, isRrpPriceTypeBeta } from "@/data/rrp";
import DocLink from "@/components/tools/DocLink.vue";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import { AgGridVue } from "ag-grid-vue3";
import { getOffers, setOffers, setOzonOldPrices } from "@/api/offer";
import { getChangeInfo, getTruncatedCellTooltip, isEditable, needChangeOldPrice } from "@/helpers/price";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import MultiSelect from 'primevue/multiselect';
import { Select } from "primevue";
import Tooltip from 'primevue/tooltip';
import { Message, Messages } from "@/data/messages";
import OffCanvas from "@/components/page/OffCanvas.vue";
import StoreLink from "@/components/price/StoreLink.vue";
import StoreGroupHeader from "@/components/price/StoreGroupHeader.vue";
import ButtonComponent from "@/components/tools/Button.vue";
import { afterStoreAction } from "@/helpers/store";
import ConfirmModal from "@/components/tools/ConfirmModal.vue";
import ProductFilters from "@/components/price/ProductFilters.vue";

export default {
  name: 'PricesView',
  // eslint-disable-next-line vue/no-unused-components
  components: {
    ButtonComponent,
    OffCanvas,
    LoadingBlock, BaseLayout, BasePagination, AgGridVue, MultiSelect, Select, ConfirmModal, ProductFilters, DocLink
  },
  directives: {
    tooltip: Tooltip
  },
  data() {
    return {
      confirmModalData: {
        title: '',
        message: '',
      },
      stores: [],
      loadingSettings: true,
      loadingOffers: false,
      loadingProducts: true,
      activeStores: [],
      storeToUpdate: '',
      OrderType: 'fbs',
      additional_params: {},
      ozon_min_price_actions: [{
        value: 'raise_error',
        label: 'Выдать ошибку'
      }, {
        value: 'change_min',
        label: 'Изменить минимальную цену'
      }],
      wbSupplyTypes: [{
        value: 'box',
        label: 'Короб'
      }, {
        value: 'pallet',
        label: 'Монопаллета'
      }],
      controlMinPrice: false,
      rrpPriceType: 'standard',
      RrpPriceTypes,
      RrpPriceTypeHint,
      RrpPriceTypeTrackingHint,
      SHOWCASE_PRICES_PATH,
      products: [],
      paginationInfo: {},
      searchData: {
        name: '',
      },
      productFilters: {},
      OrderTypes: OrderTypes,
      rowData: [],
      fixedCols: [
        {
          field: "name",
          headerName: 'Товар',
          width: 500,
          sortable: false,
          editable: true,
          tooltipValueGetter: getTruncatedCellTooltip,
        },
      ],
      colDefs: [],
      gridApi: {},
      gridOptions: {
        suppressMovableColumns: true,
        rowSelection: {
          mode: 'singleRow',
          checkboxes: false,
          enableClickSelection: true,
        },
        rowClassRules: {
          'row-in-process': (params) => {
            return params.data.in_process;
          },
        }
      },
      askIfDifference: true,
      SelectedColumns: [],
      columns: [
        {
          name: 'Артикул',
          code: 'product_code'
        },
        {
          name: 'Себестоимость',
          code: 'cost'
        },
        {
          name: 'РРЦ',
          code: 'min_price'
        },
        {
          name: 'Цена в магазине',
          code: 'price'
        },
        {
          name: 'Цена до скидки Ozon',
          code: 'ozon_old_price'
        },
        {
          name: 'Прибыль',
          code: 'profit'
        },
        {
          name: 'Налог',
          code: 'tax'
        },
        {
          name: 'Процент прибыли (от цены)',
          code: 'profit_percent'
        },
        {
          name: 'Процент прибыли (от себестоимости)',
          code: 'profit_percent_cost'
        },
        {
          name: 'Комиссия',
          code: 'commission'
        },
        {
          name: 'Информация от маркетплейса',
          code: 'marketpace_info'
        },
        {
          name: 'Ссылка на карточку',
          code: 'store_link'
        }
      ],
      wbWarehouses: [],
      loadingWbWarehouses: false,
      wbWarehouseCode: '',
      wbWarehouseSgtCode: '',
      wbFboWarehouseCode: '',
      wbSupplyType: '',
    }
  },
  computed: {
    // Получаем название первого активного магазина
    firstActiveStoreName() {
      if (this.activeStores.length > 0 && this.stores.length > 0) {
        const firstStore = this.stores.find(store => store.id === this.activeStores[0]);
        return firstStore ? firstStore.name : null;
      }
      return null;
    },
    selectedStoreIsWb() {
      return this.activeStores.some(id => {
        const s = this.stores.find(ss => ss.id === id)
        return s && s.marketplace === 'wb'
      })
    },
    selectedStoreIsOzon() {
      return this.activeStores.some(id => {
        const s = this.stores.find(ss => ss.id === id)
        return s && s.marketplace === 'ozon'
      })
    },
    selectedStoresAreOnlyYandex() {
      if (!this.activeStores.length) return false
      return this.activeStores.every(id => {
        const s = this.stores.find(ss => ss.id === id)
        return s && s.marketplace === 'yandex'
      })
    },
    needsShowcaseTracking() {
      return this.rrpPriceType === 'default' || this.rrpPriceType === 'card'
    },
    wbWarehousesForFbs() {
      return this.wbWarehouses.filter(w => w.is_for_fbs === true)
    },
    wbWarehousesForFbo() {
      if (this.wbSupplyType === 'box') {
        return this.wbWarehouses.filter(w => w.is_for_fbo_box === true)
      } else if (this.wbSupplyType === 'pallet') {
        return this.wbWarehouses.filter(w => w.is_for_fbo_pallet === true)
      }
      return this.wbWarehouses
    }
  },
  methods: {
    rrpPriceTypeLabel: formatRrpPriceType,
    isRrpPriceTypeBeta,
    async getProducts() {
      this.loadingProducts = true
      
      // Собираем все фильтры
      const filters = {
        company: user.active_company,
        ...this.productFilters,
        ...this.searchData
      }
      
      if (this.$route.query.page) {
        filters.page = parseInt(this.$route.query.page)
      }
      if (this.$route.query.size) {
        filters.size = parseInt(this.$route.query.size)
      }
      
      const result = await getProductsPost(filters)
      this.paginationInfo = {
        total: result.data.total,
        pages: result.data.pages,
        page: result.data.page,
        size: result.data.size
      }
      this.products = result.data.items
      this.setRows()
      this.loadingProducts = false
      await this.setCols()
    },
    async search() {
      const query = { ...this.$route.query }
      delete query.page
      Object.entries(this.searchData).forEach(([key, value]) => {
        if (value) {
          query[key] = value
        } else {
          delete query[key]
        }
      });
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...query
        }
      })

    },
    setSearch() {
      if (this.$route.query.name) {
        this.searchData.name = this.$route.query.name
      } else {
        this.searchData.name = ''
      }
      if (this.$route.query.brand) {
        this.searchData.brand = this.$route.query.brand
      } else {
        this.searchData.brand = ''
      }
    },
    async changePage(page) {
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: page
        }
      });
    },
    setPageInfo() {
      PageInfo.title = 'Ценообразование'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: PageInfo.title
        }
      ]
    },
    updateSettings(update_data = true) {
      price.setSettings({
        columns: this.SelectedColumns,
        orderType: this.OrderType,
        additional_params: this.additional_params,
        controlMinPrice: this.controlMinPrice,
        rrpPriceType: this.rrpPriceType,
        askIfDifference: this.askIfDifference,
        wbWarehouseCode: this.wbWarehouseCode,
        wbWarehouseSgtCode: this.wbWarehouseSgtCode,
        wbFboWarehouseCode: this.wbFboWarehouseCode,
        wbSupplyType: this.wbSupplyType
      }
      )
      if (update_data) {
        this.setRows()
        this.setCols()
      }
    },
    async setActiveStores() {
      await stores.setActiveStores(this.activeStores)
      this.setRows()
      await this.setCols()
    },
    setRows() {
      this.rowData = []
      this.products.forEach((product) => {
        this.rowData.push(
          {
            id: product.id,
            code: product.code,
            name: product.name,
            cost: product.cost,
            in_process: false,
            min_price: product.min_price,
            context: {
              code: product.code
            }
          }
        )
      })
    },
    async setCols() {
      this.colDefs = []
      this.colDefs = [...this.fixedCols]
      if (this.SelectedColumns.includes('product_code')) {
        this.colDefs.push(
          {
            field: "code", headerName: 'Артикул', width: 100, sortable: false, editable: true,
            valueParser: (params) => {
              return params.newValue
            }
          },
        )
      }
      if (this.SelectedColumns.includes('cost')) {
        this.colDefs.push(
          { field: "cost", headerName: 'Себестоимость', width: 100, sortable: false, editable: true },
        )
      }
      if (this.SelectedColumns.includes('min_price')) {
        this.colDefs.push(
          { field: "min_price", headerName: 'РРЦ', width: 100, sortable: false, editable: true },
        )
      }
      this.activeStores.forEach((store) => {
        const store_info = stores.stores.find(obj => obj['id'] === store);
        const col_context = {
          marketplace: store_info.marketplace,
          store_id: store_info.id
        }
        let children = []

        if (this.SelectedColumns.includes('price')) {
          children.push(
            {
              field: store_info.id + '_price',
              headerName: 'Цена',
              editable: (params) => isEditable(params),
              sortable: false,
              width: 100,
              context: col_context,
            }
          )
        }
        if (store_info.marketplace === 'ozon' && this.SelectedColumns.includes('ozon_old_price')) {
          children.push(
            {
              field: store_info.id + '_old_price',
              headerName: 'Цена до скидки',
              editable: (params) => isEditable(params),
              sortable: false,
              width: 130,
              context: col_context,
            }
          )
        }
        if (this.SelectedColumns.includes('profit')) {
          children.push(
            {
              field: store_info.id + '_profit_amount',
              headerName: 'Прибыль',
              editable: (params) => isEditable(params),
              sortable: false,
              width: 100,
              context: col_context,
            }
          )
        }
        if (this.SelectedColumns.includes('profit_percent')) {
          children.push(
            {
              field: store_info.id + '_profit_percent',
              headerName: '% от цены',
              wrapHeaderText: true,
              autoHeaderHeight: true,
              editable: (params) => isEditable(params),
              sortable: false,
              width: 100,
              context: col_context,
            }
          )
        }
        if (this.SelectedColumns.includes('profit_percent_cost')) {
          children.push(
            {
              field: store_info.id + '_profit_percent_cost',
              headerName: '% от себестоимости',
              wrapHeaderText: true,
              autoHeaderHeight: true,
              editable: (params) => isEditable(params),
              sortable: false,
              width: 150,
              context: col_context,
            }
          )
        }
        if (this.SelectedColumns.includes('commission')) {
          children.push(
            {
              field: store_info.id + '_commission',
              headerName: 'Комиссия',
              sortable: false,
              width: 100,
              tooltipComponent: CommissionTooltip,
              tooltipValueGetter: (p) => {
                return p
              },
              context: {
                store_id: store_info.id,
                marketplace: store_info.marketplace
              }
            }
          )
        }

        if (this.SelectedColumns.includes('tax')) {
          children.push(
            {
              field: store_info.id + '_tax',
              headerName: 'Налог',
              sortable: false,
              width: 100,
            }
          )
        }
        if (this.SelectedColumns.includes('marketpace_info')) {
          children.push(
            {
              field: store_info.id + '_marketplace_info',
              headerName: 'Информация от маркетплейса',
              sortable: false,
              width: 100,
              tooltipComponent: MarketplaceTooltip,
              tooltipValueGetter: (p) => {
                return p
              },
              context: {
                store_id: store_info.id,
                marketplace: store_info.marketplace
              },
              cellRenderer: () => {
                return '<i class="ti ti-info-circle" style="color: #007bff; cursor: pointer;"></i>'
              }
            }
          )
        }

        if (this.SelectedColumns.includes('store_link')) {
          children.push(
            {
              field: store_info.id + '_store_link',
              headerName: '',
              editable: false,
              cellRenderer: StoreLink,
              sortable: false,
              width: 60,
            }
          )
        }
        this.colDefs.push(
          {
            field: store_info.id,
            headerName: store_info.name,
            minWidth: 500,
            headerGroupComponent: StoreGroupHeader,
            headerGroupComponentParams: {
              icon: store_info.icon || getMarketplaceIcon(store_info.marketplace),
              storeName: store_info.name
            },
            children: children
          }
        )
      })
      await this.loadOffers()
      this.$nextTick(() => this.applyStickyHeader())
    },
    async loadOffers(products = null) {
      if (!products) {
        products = this.products.map((product) => product.id)
      }
      if (!products.length || !this.activeStores.length) {
        return
      }

      this.loadingOffers = true
      const company_id = await user.getActiveCompany()
      let profitParams
      // Определяем, есть ли среди активных магазинов WB
      const hasWbActive = this.activeStores.some(id => {
        const s = this.stores.find(ss => ss.id === id)
        return s && s.marketplace === 'wb'
      })
      if (hasWbActive && (this.wbWarehouseCode || this.wbWarehouseSgtCode || this.wbFboWarehouseCode || this.wbSupplyType)) {
        profitParams = {
          wb_warehouse_code: this.wbWarehouseCode || undefined,
          wb_warehouse_sgt_code: this.wbWarehouseSgtCode || undefined,
          wb_fbo_warehouse_code: this.wbFboWarehouseCode || undefined,
          wb_supply_type: this.wbSupplyType || undefined
        }
      }
      const offers = await getOffers(company_id, this.OrderType, this.activeStores, products, profitParams)
      offers.data.items.forEach((offer) => this.setOffer(offer))
      this.loadingOffers = false
    },
    setOffer(offer) {
      const row = this.rowData.find(row => offer['product_id'] === row.id)
      row[offer['store_id'] + '_price'] = offer['price']
      row[offer['store_id'] + '_old_price'] = offer['store_info']?.['old_price']
      row[offer['store_id'] + '_profit_amount'] = offer['profit_info']['profit_amount']
      row[offer['store_id'] + '_profit_percent'] = offer['profit_info']['profit_percent']
      row[offer['store_id'] + '_profit_percent_cost'] = offer['profit_info']['profit_percent_cost']
      row[offer['store_id'] + '_commission'] = offer['profit_info']['commission_amount']
      row[offer['store_id'] + '_tax'] = offer['profit_info']['tax_amount']
      row[offer['store_id'] + '_offer_id'] = offer['id']
      row[offer['store_id'] + '_store_link'] = offer['store_url']
      row[offer['store_id'] + '_marketplace_info'] = true
      row[offer['store_id']] = {
        offer_id: offer['id'],
        store_info: offer['store_info'],
        profit_info: offer['profit_info'],
        store_url: offer['store_url'],
        discount_data: offer['discount_data'] || null,
        discount_sync_enabled: !!offer['discount_sync_enabled'],
      }
      const rowNode = this.gridApi.value.getRowNode(offer['product_id']);
      rowNode.setData(row)
    },
    async onCellValueChanged(e) {
      const change = getChangeInfo(e)
      if (!await this.checkValueBeforeUpdate(change)) {
        e.data[e.colDef.field] = e.oldValue
        this.gridApi.value.redrawRows()
        return
      }
      if (change.what_to_change === 'ozon_old_price') {
        this.beforePriceChange(e)
        try {
          const result = await setOzonOldPrices(user.active_company, [{
            offer_id: change.info.offer_id,
            old_price: change.info.old_price
          }])
          this.afterOzonOldPriceChange(result, e)
        } catch (error) {
          e.data.in_process = false
          e.data[e.colDef.field] = e.oldValue
          this.gridApi.value.redrawRows()
          const message = new Message()
          message.text = error.response?.data?.detail || 'Не удалось обновить цену до скидки Ozon.'
          message.type = 'failure'
          message.format = 'notification'
          Messages.list.push(message)
        }
        return
      }
      if (change.what_to_change === 'price' || change.what_to_change === 'profit' || change.what_to_change === 'profit_percent' || change.what_to_change === 'profit_percent_cost') {
        if (change.info) {
          if (change.info['info__marketplace'] === 'ozon' && change.info['info__is_in_actions']) {
            this.confirmModalData = {
              title: 'Товар участвует в одной или нескольких акциях',
              message: 'Выберите, что необходимо сделать после обновления цены. Если нажать Убрать из акции, то товар будет удален из акций, где акционная цена ниже текущей.',
              buttons: [
                {
                  text: 'Оставить в акции',
                  value: 'keep'
                },
                {
                  text: 'Убрать из акции',
                  value: 'remove',
                  class: 'btn-primary'
                }
              ]
            }
            const result = await this.$refs.confirmModal.getAnswer()
            if (!result) {
              e.data[e.colDef.field] = e.oldValue
              this.gridApi.value.redrawRows()
              return
            }
            if (result === 'keep') {
              change.info.additional_params = {
                ...change.info.additional_params,
                ozon_remove_from_actions: false
              }
            }
            if (result === 'remove') {
              change.info.additional_params = {
                ...change.info.additional_params,
                ozon_remove_from_actions: true
              }
            }
          }
          this.beforePriceChange(e)
          change.info.order_type = this.OrderType
          change.info.additional_params = {
            ...this.additional_params,
            ...change.info.additional_params
          }
          change.info.check_rrp = this.controlMinPrice
          if (this.controlMinPrice) {
            change.info.rrp_price_type = this.rrpPriceType || 'standard'
          }
          if (this.selectedStoreIsWb && (this.wbWarehouseCode || this.wbWarehouseSgtCode || this.wbFboWarehouseCode || this.wbSupplyType)) {
            change.info.profit_params = {
              wb_warehouse_code: this.wbWarehouseCode || undefined,
              wb_warehouse_sgt_code: this.wbWarehouseSgtCode || undefined,
              wb_fbo_warehouse_code: this.wbFboWarehouseCode || undefined,
              wb_supply_type: this.wbSupplyType || undefined
            }
          }
          const offers = [change.info]
          const result = await setOffers(user.active_company, offers)
          this.afterPriceChange(result, e)
        }
      }
      if (change.what_to_change === 'cost') {
        this.beforePriceChange(e)
        const result = await updateCosts(user.active_company, [change.info.data])
        console.log(result)
        e.data.in_process = false
        await this.loadOffers([change.info.product_id])
      }
      if (change.what_to_change === 'min_price') {
        this.beforePriceChange(e)
        const result = await updateMinPrices(user.active_company, [change.info.data])
        e.data.in_process = false
        this.gridApi.value.redrawRows()
        console.log(result)
      }
    },
    async checkValueBeforeUpdate(change) {
      if (change.what_to_change === 'price' || change.what_to_change === 'cost' || change.what_to_change === 'min_price') {
        if (
          change.what_to_change === 'price' &&
          change.info['info__marketplace'] === 'ozon' &&
          needChangeOldPrice(change.info['price'], change.info['info__old_price'])
        ) {
          this.confirmModalData = {
            title: 'Подтверждение изменения',
            message: 'После изменения цены Ozon сбросит цену до скидки, так как разница между ценой до и после скидки не соответствует требованиям Ozon. Продолжить?',
          }
          const result = await this.$refs.confirmModal.getAnswer()
          if (!result) {
            return false
          }
        }
        if (change.info['difference'] > 0.2 && this.askIfDifference) {
          this.confirmModalData = {
            title: 'Подтверждение изменения',
            message: 'Новое значение отличается от старой больше чем на 20%, вы уверены, что хотите продолжить?',
          }
          const result = await this.$refs.confirmModal.getAnswer()
          return result
        }
      }
      if (change.what_to_change === 'profit' || change.what_to_change === 'profit_percent' || change.what_to_change === 'profit_percent_cost') {
        if (change.info['difference'] > 0.5 && this.askIfDifference) {
          this.confirmModalData = {
            title: 'Подтверждение изменения',
            message: 'Новое значение отличается от старой больше чем на 50%, вы уверены, что хотите продолжить?',
          }
          const result = await this.$refs.confirmModal.getAnswer()
          return result
        }
      }
      return true
    },
    beforePriceChange(e) {
      e.data.in_process = true
      this.gridApi.value.redrawRows()
    },
    afterPriceChange(result, e) {
      e.data.in_process = false
      const data = result.data || {}
      const offers = data.offers || []
      const results = data.results || []
      const skipped = data.skipped || []

      offers.forEach((offer) => this.setOffer(offer))

      let success = results.filter((item) => item['result'] === 'success')
      let failure = results.filter((item) => item['result'] === 'failure')

      if (success.length) {
        const successText = success.map((item) => {
          let text = item.product_code
          if (item.rrp_applied) {
            const rrpValue = item.rrp?.parsedValue ?? item.rrp?.source
            const typeLabel = formatRrpPriceType(item.rrp_price_type)
            const parts = ['применён контроль РРЦ']
            if (rrpValue != null && rrpValue !== '') {
              parts.push(`РРЦ ${rrpValue}`)
            }
            if (item.rrp_price_type) {
              parts.push(typeLabel)
            }
            text += ` (${parts.join(', ')})`
          }
          return text
        })
        const text = 'Цены успешно обновлены для товаров: ' + successText.join(', ') + '.'
        const message = new Message()
        message.text = text
        message.type = 'success'
        message.autoremove = 5
        message.format = 'notification'
        Messages.list.push(message)
      }
      if (failure.length) {
        failure = failure.map((
          { message, product_code }) => (product_code + ' (' + message + ')'));
        const text = 'Ошибка при обновлении цен: ' + failure.join(',') + '.'
        const message = new Message()
        message.text = text
        message.type = 'failure'
        message.format = 'notification'
        Messages.list.push(message)
      }
      if (skipped.length) {
        const skippedText = skipped.map((
          { message, product_code }) => (product_code + ' (' + message + ')'));
        const message = new Message()
        message.text = 'Цена не обновлена, товар пропущен: ' + skippedText.join(',') + '.'
        message.type = 'failure'
        message.format = 'notification'
        Messages.list.push(message)
      }

      // Если сервер ничего не обновил — откатываем значение в ячейке
      if (!success.length && (failure.length || skipped.length)) {
        e.data[e.colDef.field] = e.oldValue
      }
      this.gridApi.value.redrawRows()
    },
    afterOzonOldPriceChange(result, e) {
      e.data.in_process = false
      const data = result.data || {}
      const results = data.results || []
      const skipped = data.skipped || []
      const success = results.filter((item) => item.result === 'success')
      const failure = results.filter((item) => item.result === 'failure')

      if (success.length) {
        const message = new Message()
        message.text = 'Цена до скидки Ozon успешно обновлена для товаров: ' +
          success.map((item) => item.product_code || item.offer_id).join(', ') + '.'
        message.type = 'success'
        message.autoremove = 5
        message.format = 'notification'
        Messages.list.push(message)
      }
      if (failure.length) {
        const message = new Message()
        message.text = 'Ошибка при обновлении цены до скидки Ozon: ' +
          failure.map((item) => `${item.product_code || item.offer_id} (${item.message})`).join(', ') + '.'
        message.type = 'failure'
        message.format = 'notification'
        Messages.list.push(message)
      }
      if (skipped.length) {
        const message = new Message()
        message.text = 'Цена до скидки Ozon не обновлена, товар пропущен: ' +
          skipped.map((item) => `${item.product_code || item.offer_id} (${item.message})`).join(', ') + '.'
        message.type = 'failure'
        message.format = 'notification'
        Messages.list.push(message)
      }

      if (!success.length) {
        e.data[e.colDef.field] = e.oldValue
      }
      this.gridApi.value.redrawRows()
    },
    onGridReady(params) {
      this.gridApi.value = params.api;
      this.bindStickyHeader()
      this.$nextTick(() => this.applyStickyHeader())
    },
    getPricesGridEl() {
      const grid = this.$refs.pricesGrid
      if (grid instanceof HTMLElement) return grid
      if (grid?.$el instanceof HTMLElement) return grid.$el
      return document.querySelector('.prices-grid')
    },
    getPricesHeaderEl() {
      return this.getPricesGridEl()?.querySelector?.('.ag-header') || null
    },
    pinPricesHeader(header, gridEl) {
      const headerHeight = header.offsetHeight || 0
      if (!this._headerPlaceholder) {
        this._headerPlaceholder = document.createElement('div')
        this._headerPlaceholder.className = 'prices-header-placeholder'
        header.parentNode.insertBefore(this._headerPlaceholder, header)
      }
      this._headerPlaceholder.style.height = `${headerHeight}px`

      if (!this._headerOverflowRestores) {
        this._headerOverflowRestores = []
        const overflowEls = [
          gridEl.querySelector('.ag-root-wrapper'),
          gridEl.querySelector('.ag-root-wrapper-body'),
          gridEl.querySelector('.ag-root'),
        ].filter(Boolean)
        overflowEls.forEach((el) => {
          this._headerOverflowRestores.push({ el, overflow: el.style.overflow })
          el.style.overflow = 'visible'
        })
      }

      const gridRect = gridEl.getBoundingClientRect()
      header.classList.add('prices-header-stuck')
      header.style.position = 'fixed'
      header.style.top = '0px'
      header.style.left = `${Math.round(gridRect.left)}px`
      header.style.width = `${Math.round(gridRect.width)}px`
      header.style.height = `${headerHeight}px`
      header.style.zIndex = '20'
      header.style.overflow = 'hidden'
      header.style.backgroundColor = '#fff'
      header.style.boxShadow = '0 2px 8px rgba(47, 43, 61, 0.12)'
      this._headerStuck = true
    },
    unpinPricesHeader(header) {
      if (this._headerOverflowRestores) {
        this._headerOverflowRestores.forEach(({ el, overflow }) => {
          el.style.overflow = overflow
        })
        this._headerOverflowRestores = null
      }
      if (this._headerPlaceholder) {
        this._headerPlaceholder.remove()
        this._headerPlaceholder = null
      }
      if (header) {
        header.classList.remove('prices-header-stuck')
        header.style.position = ''
        header.style.top = ''
        header.style.left = ''
        header.style.width = ''
        header.style.height = ''
        header.style.zIndex = ''
        header.style.overflow = ''
        header.style.backgroundColor = ''
        header.style.boxShadow = ''
      }
      this._headerStuck = false
    },
    applyStickyHeader() {
      const gridEl = this.getPricesGridEl()
      const header = this.getPricesHeaderEl()
      if (!gridEl || !header) {
        this.unpinPricesHeader(header)
        return
      }

      const headerHeight = this._headerPlaceholder
        ? this._headerPlaceholder.offsetHeight
        : (header.offsetHeight || 0)
      const gridRect = gridEl.getBoundingClientRect()
      const headerTop = this._headerStuck && this._headerPlaceholder
        ? this._headerPlaceholder.getBoundingClientRect().top
        : header.getBoundingClientRect().top
      const shouldStick = headerTop < 0 && gridRect.bottom - headerHeight > 0

      if (!shouldStick) {
        this.unpinPricesHeader(header)
        return
      }
      this.pinPricesHeader(header, gridEl)
    },
    updateStickyHeader() {
      if (this._stickyHeaderFrame) return
      this._stickyHeaderFrame = requestAnimationFrame(() => {
        this._stickyHeaderFrame = null
        this.applyStickyHeader()
      })
    },
    bindStickyHeader() {
      if (!this._onStickyHeader) {
        this._onStickyHeader = () => this.updateStickyHeader()
        window.addEventListener('scroll', this._onStickyHeader, { passive: true, capture: true })
        document.addEventListener('scroll', this._onStickyHeader, { passive: true, capture: true })
        window.addEventListener('resize', this._onStickyHeader)
      }
      const layoutPage = document.querySelector('.layout-page')
      if (layoutPage && layoutPage !== this._stickyScrollParent) {
        if (this._stickyScrollParent && this._stickyScrollParent !== window) {
          this._stickyScrollParent.removeEventListener('scroll', this._onStickyHeader)
        }
        this._stickyScrollParent = layoutPage
        layoutPage.addEventListener('scroll', this._onStickyHeader, { passive: true })
      }
      this.applyStickyHeader()
    },
    unbindStickyHeader() {
      if (this._stickyHeaderFrame) {
        cancelAnimationFrame(this._stickyHeaderFrame)
        this._stickyHeaderFrame = null
      }
      if (this._onStickyHeader) {
        window.removeEventListener('scroll', this._onStickyHeader, { capture: true })
        document.removeEventListener('scroll', this._onStickyHeader, { capture: true })
        window.removeEventListener('resize', this._onStickyHeader)
        if (this._stickyScrollParent && this._stickyScrollParent !== window) {
          this._stickyScrollParent.removeEventListener('scroll', this._onStickyHeader)
        }
        this._onStickyHeader = null
        this._stickyScrollParent = null
      }
      this.unpinPricesHeader(this.getPricesHeaderEl())
    },
    getRowId(params) {
      return params.data.id;
    },
    openSettings() {
      this.$refs.priceCanvas.open()
    },
    closeSettings() {
      this.$refs.priceCanvas.close()
    },
    async fetchWbWarehouses() {
      if (this.wbWarehouses && this.wbWarehouses.length > 0) {
        return
      }
      this.loadingWbWarehouses = true
      try {
        const res = await getWbWarehouses()
        this.wbWarehouses = (res.data || []).map(w => ({...w, _label: `${w.name}`}))
      } catch (e) {
        this.wbWarehouses = []
      }
      this.loadingWbWarehouses = false
    },
    async storeGetOffers() {
      if (this.storeToUpdate.length) {
        this.$refs.getOffersButton.startLoading()
        try {
          const result = await StoreGetOffers(this.storeToUpdate)
          afterStoreAction(result)
        } catch (exception) {
          afterStoreAction(exception.response)
        }
        this.$refs.getOffersButton.endLoading()
        this.closeSettings()
        await this.loadOffers()
      }
    },
    handleProductFiltersChanged(filters) {
      this.productFilters = filters;
      // Сбрасываем страницу при изменении фильтров
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: 1
        }
      }).then(() => {
        this.getProducts();
      });
    },
  },
  async mounted() {
    this.setPageInfo()
    this.setSearch()
    await user.getUserBase()
    
    // Проверка активности тарифа
    const isActive = await subscription.isActive()
    if (!isActive) {
      await router.push({ name: 'payment', query: { error: 'expired' } })
      return
    }
    
    this.stores = await stores.getStores()
    this.activeStores = await stores.getActiveStores()
    // Если ни один магазин не выбран, выбираем первый по умолчанию
    if (this.activeStores.length === 0 && this.stores.length > 0) {
      this.activeStores = [this.stores[0].id]
      await stores.setActiveStores(this.activeStores)
    }
    const settings = price.getSettings()
    this.SelectedColumns = settings.columns
    this.OrderType = settings.orderType
    this.additional_params = settings.additional_params || {
      ozon_min_price_action: 'raise_error'
    }
    this.controlMinPrice = settings.controlMinPrice || false
    this.rrpPriceType = settings.rrpPriceType || 'standard'
    this.askIfDifference = settings.askIfDifference
    // Restore WB warehouses selection if present
    this.wbWarehouseCode = settings.wbWarehouseCode || ''
    this.wbWarehouseSgtCode = settings.wbWarehouseSgtCode || ''
    this.wbFboWarehouseCode = settings.wbFboWarehouseCode || ''
    this.wbSupplyType = settings.wbSupplyType || ''
    this.loadingSettings = false
    // Если среди активных магазинов есть WB — загрузить склады
    if (this.selectedStoreIsWb) {
      await this.fetchWbWarehouses()
    }
    await this.getProducts()
  },
  beforeUnmount() {
    this.unbindStickyHeader()
  },
  watch: {
    '$route'() {
      this.setSearch()
      this.setPageInfo()
      this.getProducts()
    },
    activeStores() {
      // При изменении активных магазинов — если появился WB, загружаем склады
      if (this.selectedStoreIsWb) {
        this.fetchWbWarehouses()
      }
    },
    wbSupplyType() {
      // При изменении типа поставки проверяем, соответствует ли выбранный склад
      if (this.wbFboWarehouseCode && this.wbWarehousesForFbo.length > 0) {
        const selectedWarehouse = this.wbWarehousesForFbo.find(w => w.code === this.wbFboWarehouseCode)
        if (!selectedWarehouse) {
          // Выбранный склад не соответствует новому типу поставки, очищаем
          this.wbFboWarehouseCode = ''
          this.updateSettings()
        }
      }
    }
  }
}
</script>

<style>
.ag-theme-quartz {
  --ag-header-background-color: white;
  --ag-wrapper-border-radius: 0;
}

.prices-grid {
  width: 100%;
  max-width: 100%;
}

.prices-grid .ag-root-wrapper {
  border: 0;
}

.prices-header-stuck {
  box-sizing: border-box;
}

.prices-grid .ag-header-group-cell {
  display: flex !important;
  align-items: center !important;
}

.prices-grid .ag-header-group-cell .ag-header-cell-comp-wrapper {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
  width: 100%;
}

.row-in-process {
  background-color: #bee2ff;
}

.price-top-row .p-multiselect, .price-top-row button{
  height: 40px;
}

.rrp-beta {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  line-height: 1.4;
  background: rgba(115, 103, 240, 0.12);
  color: #7367f0;
}

.ag-theme-quartz .ag-cell[col-id="name"],
.ag-theme-quartz .ag-cell[col-id="name"] .ag-cell-wrapper,
.ag-theme-quartz .ag-cell[col-id="name"] .ag-cell-value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.ag-theme-quartz .ag-tooltip:not(:has(.popover)) {
  max-width: 480px;
  white-space: normal;
  overflow-wrap: anywhere;
  line-height: 1.35;
}
</style>
